export default "__VITE_ASSET__ec916a51__"